import { YStack, XStack, Text, View, Button } from "tamagui";
import { colors } from "@styles/colors";
import { useHazePage, v2 } from "@screen/Home/pages/GasShop/skin";
import { Fade, RADIUS } from "./Common";
import { Ic } from "./Icons";
import RadiusContentWrapper from "@components/layout/RadiusContentWrapper";
import { RiCloseCircleLine, RiErrorWarningLine } from "react-icons/ri";

export default function JoinError({ errorType, code, onRetry, onCancel }: any) {
  // 淡霧頁：這一組白字與白色圖示原本坐在藍色漸層上，換皮後在淡藍白底上完全讀不到
  const haze = useHazePage();
  const info = (
    {
      expired: {
        icon: "M12 8v4l3 3M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
        title: "邀請碼已過期",
        sub: "這組碼超過有效期限，請聯絡邀請人重新產生一組新的",
      },
      invalid: { icon: "M18 6L6 18M6 6l12 12", title: "查無此邀請碼", sub: "請確認 6 位數字是否正確，或請邀請人重新提供" },
    } as any
  )[errorType] || {
    icon: "M12 9v4M12 17h.01M21 12A9 9 0 113 12a9 9 0 0118 0z",
    title: "加入失敗",
    sub: "發生未知錯誤，請稍後再試",
  };

  return (
    <RadiusContentWrapper padding="0" space={0} background="transparent">
      <YStack>
        {/* 慶祝／錯誤的標頭直接坐在整頁漸層上：原本是一塊自帶漸層、下緣圓角 35 的色卡，
            疊在 V2 的頁面漸層上會變成兩層底色，交界看得到一道邊。 */}
        <YStack
          pb="$5"
          px="$5"
          position="relative"
          ov="hidden">
          <View h={30} />
          <YStack ai="center" position="relative">
            <RiCloseCircleLine color={haze ? colors.danger : "#ffffffd8"} size={50} />
            <Text fontSize={22} fontWeight="800" color={haze ? v2.hazeInk : "#fff"} mb="$1">
              無法加入帳戶
            </Text>
            <Text fontSize={14} color={haze ? v2.hazeSub : "rgba(255,255,255,0.88)"}>
              邀請碼驗證失敗
            </Text>
          </YStack>
        </YStack>

        <YStack p="$5" gap="$4">
          <Fade i={0}>
            <YStack bg={colors.light} br={RADIUS} p="$5" ai="center" gap="$3">
              <View w={82} h={82} br={41} bg={colors.bgRed} ai="center" jc="center">
                <Ic d={info.icon} c={colors.danger} s={38} sw={2} />
              </View>
              <YStack ai="center" gap="$2">
                <Text fontSize={21} fontWeight="800" color={colors.grayDark}>
                  {info.title}
                </Text>
                <Text fontSize={13} color={colors.gray} ta="center" maw={280} lineHeight={20}>
                  {info.sub}
                </Text>
              </YStack>
            </YStack>
          </Fade>

          <Fade i={1}>
            <XStack bg={colors.light} br={RADIUS} p="$4" ai="center" gap="$3">
              <View br={7} bg={colors.bg} ai="center" jc="center" p="$2">
                <Text fontSize={15} fontWeight="800" color={colors.gray}>
                  {code}
                </Text>
              </View>
              <YStack f={1}>
                <Text fontSize={11} color={colors.gray200}>
                  你輸入的邀請碼
                </Text>
                <Text fontSize={13} fontWeight="700" color={colors.danger} mt={1}>
                  驗證失敗
                </Text>
              </YStack>
            </XStack>
          </Fade>

          <Fade i={2}>
            <XStack bg={colors.bgAmber} br={RADIUS} p="$4" gap="$2.5">
              <RiErrorWarningLine size={18} color={colors.amber} />
              <YStack f={1}>
                <Text fontSize={12} fontWeight="700" color={colors.amberDark} mb={2}>
                  下一步
                </Text>
                <Text fontSize={11} color={colors.amberDark} lineHeight={16}>
                  聯絡邀請人，請他在帳戶頁點「邀請成員」→「產生新邀請碼」，把新的 6 位數碼給你。
                </Text>
              </YStack>
            </XStack>
          </Fade>
        </YStack>

        <YStack backgroundColor={colors.bg} px="$4" pt={8} gap="$2.5" style={{ position: "sticky", bottom: "0", width: "100%", zIndex: 100 }}>
          <XStack gap="$2.5" mb="$2">
            <Button f={1} bg={colors.bg} color={colors.gray} fontWeight="600" h={50} onPress={onCancel} br={15} bw={0}>
              取消
            </Button>
            <Button
              f={2}
              className="primary-bg-gradient"
              color="#fff"
              fontWeight="700"
              h={50}
              onPress={onRetry}
              br={15}
              bw={0}
              style={{ boxShadow: `0 4px 14px ${colors.primary}40` }}>
              重新輸入
            </Button>
          </XStack>
        </YStack>
      </YStack>
      <style>{`@keyframes popIn { 0% { transform:scale(0); opacity:0; } 60% { transform:scale(1.08); } 100% { transform:scale(1); opacity:1; } }`}</style>
    </RadiusContentWrapper>
  );
}
